import React, { ChangeEvent, useState } from 'react';
import { Controller, SubmitHandler, UseFormReturn } from 'react-hook-form';
import { PartialDowntime } from 'entities/financeOperations/types';
import { Select, MenuItem, FormControl, InputLabel, Checkbox, Box, Button } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useGetReasonsQuery } from 'entities/financeOperations/api';
import dayjs, { Dayjs } from 'dayjs';

type FinanceOperationsEditReasonFormPropsType = {
  form: UseFormReturn<PartialDowntime>;
  onSubmit: (data: PartialDowntime) => SubmitHandler<PartialDowntime>;
};
export const FinanceOperationsEditReasonForm = ({ form, onSubmit }: FinanceOperationsEditReasonFormPropsType) => {
  const { data: reasonsList } = useGetReasonsQuery(null);
  const [enableDate, setEnableDate] = useState(true);
  const { control, setValue, handleSubmit } = form;

  const handleDateChange = (value: Dayjs | null, onChange: (...event: any[]) => void) => {
    onChange(value ? dayjs(value).format('YYYY-MM-DDTHH:mm') : null);
  };
  const checkboxClickChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    if (!checked) {
      setValue('unavailable_until_at', null);
    }
    setEnableDate(event.target.checked);
  };

  return (
    <>
      <Box
        sx={{
          marginBottom: '24px',
        }}
      >
        <Controller
          control={control}
          name="reason_id"
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel id="select-label">Причина</InputLabel>
              <Select
                labelId="select-label"
                label="Причина"
                sx={{
                  marginBottom: '24px',
                }}
                {...field}
              >
                {reasonsList?.map((reason) => (
                  <MenuItem value={reason.id}>{reason.title.ru}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
        <Box
          sx={{
            marginBottom: '24px',
          }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="en-gb"
          >
            <Controller
              control={control}
              name="unavailable_until_at"
              render={({ field: { value, onChange, ...restField } }) => (
                <DateTimePicker
                  disabled={!enableDate}
                  value={dayjs(value)}
                  onChange={(value) => handleDateChange(value, onChange)}
                  label="Не доступно до"
                  {...restField}
                />
              )}
            />
          </LocalizationProvider>
        </Box>
        <Checkbox
          checked={enableDate}
          onChange={checkboxClickChange}
        />{' '}
        Включить дату
      </Box>

      <Button
        variant="contained"
        onClick={handleSubmit(onSubmit)}
      >
        Сохранить
      </Button>
    </>
  );
};
